import React from "react";
import './results.css';
import ContextData from './../../context/Data/ContextData';
import { useNavigate } from 'react-router-dom'; 
import axios from 'axios';   

const Results = () => {   
    const {stateData} = React.useContext(ContextData);
    let navigate = useNavigate();

    React.useEffect(() => { 
        if(stateData.contextUserAnswers[0] === -1) {    
            return navigate("../", { replace: true });
        }
    });

 
  return ( 
    <> 
        <div className="results__top">
            <div className="results__topScore">{stateData.contextScore} / 5</div>
            <div className="results__topText">{stateData.contextTitles[stateData.contextScore]}</div>
        </div>
        <div className="resultsWrapper">
            <div className="results">
                {stateData.contextQuestionsForUser.map((el, i) => {  
                    return (
                        <div className="results__itemWrapper" key={'rq'+i}>
                            <div  className={"results__item "+(stateData.contextQuestions[el].correct === stateData.contextUserAnswers[i] ? 'correct' : '')}>
                                <div className="results__ava">
                                    <img src={"assets/img/question"+el+"/ico.svg"} alt="ico" className="results__ico" />
                                </div>
                                <div className="results__name" dangerouslySetInnerHTML={{ __html: stateData.contextQuestions[el].answers[stateData.contextQuestions[el].correct] }} />
                                <div className="results__text" dangerouslySetInnerHTML={{ __html: stateData.contextQuestions[el].text }} />
                            </div>
                        </div>
                    ); 
                })}
            </div>
            <button className="btn results__btn" type="button" onClick={()=>{ 
                window["ym"](88899563,'reachGoal', 'game_guess_who_LastScreen', {status: (stateData.contextScore+'5')}); 
                axios.get('/api.php', { params: { ip: window.ip, key: 'final' } })                
                return navigate("../final", { replace: false }); 
            }}>Продолжить</button> 
        </div>
    </>
  );
};

export default Results;
